import {
  faGlobe,
  faMountain,
  faSitemap,
  faMapPin,
  faUser,
  faGem,
  faBox,
  faBolt,
  faDragon,
  faScroll,
  faCrosshairs,
  faFolder,
} from "@fortawesome/free-solid-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export interface AssetTypeConfig {
  icon: IconDefinition;
  color: string;
  bg: string;
  border: string;
  label: string;
}

export const TYPE_CONFIG: Record<string, AssetTypeConfig> = {
  World: {
    icon: faGlobe,
    color: "text-sky-400",
    bg: "bg-sky-400/10",
    border: "border-sky-400/30",
    label: "World",
  },
  GeographicalElement: {
    icon: faMountain,
    color: "text-teal-400",
    bg: "bg-teal-400/10",
    border: "border-teal-400/30",
    label: "Geographical Element",
  },
  Organization: {
    icon: faSitemap,
    color: "text-violet-400",
    bg: "bg-violet-400/10",
    border: "border-violet-400/30",
    label: "Faction",
  },
  Location: {
    icon: faMapPin,
    color: "text-sky-400",
    bg: "bg-sky-400/10",
    border: "border-sky-400/30",
    label: "Location",
  },
  Character: {
    icon: faUser,
    color: "text-emerald-400",
    bg: "bg-emerald-400/10",
    border: "border-emerald-400/30",
    label: "NPC",
  },
  Beast: {
    icon: faDragon,
    color: "text-orange-400",
    bg: "bg-orange-400/10",
    border: "border-orange-400/30",
    label: "Beast",
  },
  Item: {
    icon: faGem,
    color: "text-amber-400",
    bg: "bg-amber-400/10",
    border: "border-amber-400/30",
    label: "Item",
  },
  Event: {
    icon: faBolt,
    color: "text-rose-400",
    bg: "bg-rose-400/10",
    border: "border-rose-400/30",
    label: "Event",
  },
  Quest: {
    icon: faScroll,
    color: "text-yellow-400",
    bg: "bg-yellow-400/10",
    border: "border-yellow-400/30",
    label: "Quest",
  },
  Encounter: {
    icon: faCrosshairs,
    color: "text-red-400",
    bg: "bg-red-400/10",
    border: "border-red-400/30",
    label: "Encounter",
  },
  Folder: {
    icon: faFolder,
    color: "text-zinc-300",
    bg: "bg-zinc-300/10",
    border: "border-zinc-300/30",
    label: "Folder",
  },
};

const DEFAULT_TYPE_CONFIG: AssetTypeConfig = {
  icon: faBox,
  color: "text-zinc-400",
  bg: "bg-zinc-400/10",
  border: "border-zinc-400/30",
  label: "Unknown",
};

export const getTypeConfig = (type: string): AssetTypeConfig =>
  TYPE_CONFIG[type] ?? DEFAULT_TYPE_CONFIG;
